import { TValidationResult } from '@settings/data-access';

export enum SystemModules {
  Totalpass = '7d306ae7-3a62-4d2e-bbb7-ec973f029a84',
  Gympass = '78567d75-39c1-43df-9ece-cc32ff554de2',
  Facial = '033ac824-6786-4071-9180-e9c10d742ef1',
  TreiNo = '38299a3b-5e4c-447a-ba9a-ab9e7f19b4d2',
  CRM = '6e2a0f78-a58f-47be-8f91-85babcbe5b9f',
  Actuar = '45c45478-0efc-4def-8ff9-7636e3e72c18',
  Administrativo = 'cf7ff341-2052-458c-97f4-3ca8cf83b91d',
  Whatsapp = 'd8fda503-805e-4746-8003-f2c050b03321',
  Sms = '83a29482-8b98-4c00-b70d-770d0542d9b0',
  Email = 'faf2b2ce-f5ee-495b-b55f-060ae0782e63',
  Helpdesk = 'aecd8154-509a-4eec-9533-0ef14b975e35',
  Apuracao = '6cb379c9-65f4-4e68-86f9-ac3956c9f257',
  AvaliacaoFisica = '3085ce66-a968-49ee-a88e-b5b9c7e2e59a',
  Gestor = '475658a0-236b-4772-b77b-e771ecca66d2',
  Contratos = '6be95655-afba-492d-90d4-4637397b3b84',
  ActuarWeb = 'f45c6900-64d6-4e04-a273-46a410501532',
  Cobranca = 'b733f377-b7b1-4701-b654-62ee6d835137',
  NotaFiscal = '2322c49a-0ba8-4056-9854-3892edfe3f16',
  Acesso = '24a44ab0-4d95-4e98-9eb5-587553c5d7e4',
  Integrations = 'c4fda503-805e-4746-8003-f2c050b03578',
  Reservas = '9c8d007f-fe34-442e-ba8a-1f1dc12f5282',
  Servicos = '9963dd95-6300-4b9a-bd96-3776b42fddca',
  Mercadorias = '6df2bc9f-5653-409d-a8b9-d9baa6e8cc45',
  Assinaturas = 'c286fddd-2ec1-4799-baea-cbfd4ad84d66',
}

/**
 * Ate quando cada produto do inquilino esta disponivel — `GET /Subscription/GetProductsByPerson`.
 *
 * NAO e o mesmo que `TPersonModule`, ainda que os nomes se pareçam: aquele vem de
 * `/Person/products` e diz se o modulo esta ATIVO agora; este diz ate QUANDO estara. Um traz
 * `IsActive`/`IsValid` e nao traz data; o outro traz a data e nao traz o estado. Sao dois pedidos.
 *
 * `AvailableUntilUtc` e a data do bloqueio. O sufixo `Utc` nao e enfeite: e o que faz o
 * `DateInterceptor` converter o instante para a hora de parede da conta na resposta — o que
 * significa que aqui ele JA CHEGA local e sem offset. Parsear com `{ zone: 'utc' }` deslocava-o
 * pela segunda vez.
 */
export type TPersonProductValidity = {
  ProductId: string;
  Name: string;
  Icon: string;
  CategoryType: number;
  AvailableUntilUtc: string;
};

export type TPersonModule = {
  ProductId: string;
  Name: string;
  Icon: string;
  CategoryType: number;
  IsActive: boolean;
  Operation: unknown | null;
  ValidationResult: TValidationResult;
  IsValid: boolean;
};

